/* eslint no-prototype-builtins: 0 */
export default Object.setPrototypeOf ||
	({ __proto__: [] } instanceof Array ? setProtoOf : inheritProperties);

function setProtoOf(obj: any, proto: any) {
	obj.__proto__ = proto;
	return obj;
}

function inheritProperties(obj: any, proto: any) {
	const props = Object.getOwnPropertyNames(proto);
	for (let i = 0; i < props.length; i++) {
		const prop = props[i];
		if (!obj.hasOwnProperty(prop)) {
			Object.defineProperty(obj, prop, {
				get: (function (prop) {
					return function () {
						return proto[prop];
					};
				})(prop),
				set: (function (prop) {
					return function (val: any) {
						delete obj[prop];
						obj[prop] = val;
					};
				})(prop),
				enumerable: proto.propertyIsEnumerable(prop),
				configurable: true,
			});
		}
	}
	return obj;
}
